
// These imports work because we are using @rollup/plugin-url.
// See package.json and rollup.config.js

import connectorUrl from './connector.vef'

const shapes = {
  connector: connectorUrl,
}

export default shapes